import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import UserNavigation from '../../../Components/v1/NavBar/Navigaton';
import {
  GetSpecificProperty,
  auctionCreateLog,
} from "../../../Api/Api";
import Navigation from "../../../Components/Navbar/Navigation";
import Footer from "../../../Components/Footer/Footer";
import ScheduleMeetBanner from "../../../Components/v1/Home/ScheduleMeetBanner";
import Testimonial from "../../../Components/v1/Home/Testimonial";
import AppDownload from "../../../Components/v1/Home/AppDownload";
import FAQ from "../../../Components/v1/Home/FAQ";
import Newsletter from "../../../Components/v1/Home/Newletter";
import { createAPI, fetchWithQueryAPI } from "../../../Api/v1/Util/Api";
import { auction_payment_initiate, auction_user_findProperty_url, dalmaf_user_findProperty_url } from "../../../Api/APIUrl";
let htmlToDraft = null;
if (typeof window === "object") {
  htmlToDraft = require("html-to-draftjs").default;
}

const PropertyUserViewAuctionDetail = () => {
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const { id } = useParams();

  const [loginModal, setLoginModal] = useState(false);
  const [showResponse, setShowResponse] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
    getSpecificAuctionList();
    createAuctionView();
  }, []);

  const createAuctionView = async () => {
    const token = state?.auth?.auth?.token;
    const response = await auctionCreateLog(token, id);
  }
  const [property, setProperty] = useState({
    floor_information: [{ floor_no: "", floor_image: "", floor_desc: "" }],
  });

  const makePayment = async () => {
    const token = state?.auth?.auth?.token;
    const fd = new FormData(); // Corrected syntax
    fd.append('reference_id', id); // Corrected method to append data

    try {
      const response = await createAPI(token, auction_payment_initiate, fd);
      // Handle the response if needed
      if(response.statusCode===200){
        if (response.data.url) {
          // Redirect the user to the URL returned in the API response
          window.location.href = response.data.url;
        } else {
          console.error('No URL provided in the response');
        }
      }
    } catch (error) {
      // Handle error if the API call fails
      console.error('Payment initiation failed:', error);
    }
  };

  const getSpecificAuctionList = async () => {
    const token = state?.auth?.auth?.token;
    // const response = await GetSpecificProperty(id);
    const response = await fetchWithQueryAPI(token, auction_user_findProperty_url + '?_id=' + id)
    if (response && response.statusCode === 200) {
      let dummy = response.data;
      let cmsDescription = EditorState.createEmpty();
      if (dummy.property_desc) {
        let blocksFromHtml = htmlToDraft(dummy.property_desc);
        let { contentBlocks, entityMap } = blocksFromHtml;
        let contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );
        cmsDescription = EditorState.createWithContent(contentState);
      }
      dummy.property_desc = cmsDescription;
      setProperty(dummy);
      setShowResponse(true)
    } else if (response && response.statusCode === 201) {
      setLoginModal(true);
      setShowResponse(false)
    } else {
      setProperty({});
      setShowResponse(false)
      errorMsg(response.message);
    }
  };
  const [validation, setValidation] = useState({});
  const setData = (e, key) => {
    setProperty({ ...property, [key]: e });
    if (validation[key]) delete validation[key];
  };

  const errorMsg = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  return (
    <>
      {/* <Navigation /> */}
      <UserNavigation />
      <div
        className={`modal fade ${loginModal ? 'show d-block' : ''}`}
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white" style={{ backgroundColor: '#dc3545' }}>
              <h5 className="modal-title">Validate Purchase History</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setLoginModal(!loginModal)}
              ></button>
            </div>
            <div className="modal-body text-center">
              <h5 className="mb-4">To know more about this auction property, you need to purchase access for ₹20</h5>
              <button className="btn text-white" style={{ backgroundColor: '#dc3545', color: "white" }} onClick={makePayment}>Buy Now ₹20 </button>
            </div>
          </div>
        </div>
      </div>
      {
        showResponse &&
        (<>
          <div className="container py-4">
            <div className="d-flex justify-content-between align-items-center mb-4 bg-light rounded-3 p-4 shadow-sm mb-4">
              <h5 className="mb-0" style={{color:'#dc3545'}}>Property Details</h5>
              <button
                type="button"
                className="btn btn-primary btn-lg shadow-sm rounded-pill px-4"
                onClick={() =>
                  navigate(
                    "/Service?tab=Other%20Services&subtab=Auctions%20|%20Property%20Auction&id=6650d90bb06b79232c3c49b2"
                  )
                }
              >
                Back
              </button>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Property Id</h6>
                    <p className="card-text fs-6">{property.property_id}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Property Type</h6>
                    <p className="card-text fs-6">{property.property_type}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Possession Status</h6>
                    <p className="card-text fs-6">{property.possession_status}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Bank Name</h6>
                    <p className="card-text fs-6">{property.bank}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Reserve Price</h6>
                    <p className="card-text fs-6">{property.reserve_price}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">EMD Amount</h6>
                    <p className="card-text fs-6">{property.emd_amount}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Auction Date</h6>
                    <p className="card-text fs-6">{property.auction_date}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">EMD Submission Last Date</h6>
                    <p className="card-text fs-6">{property.emd_submission_last_date}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Borrower Name</h6>
                    <p className="card-text fs-6">{property.borrower_name}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Bank Contact Details</h6>
                    <p className="card-text fs-6">{property.bank_contact_details}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Location</h6>
                    <p className="card-text fs-6">{property.location}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Area</h6>
                    <p className="card-text fs-6">{property.area}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">City</h6>
                    <p className="card-text fs-6">{property.city}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Created By</h6>
                    <p className="card-text fs-6">{property?.userId}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Property Description</h6>
                    <div
                      dangerouslySetInnerHTML={{ __html: property?.description }}
                    ></div>
                    {validation.description && (
                      <p className="text-danger">{validation.description}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Sale Notice URL</h6>
                    <div className="text-center">
                      {property.sale_notice_url?.length ? (
                        property.sale_notice_url.map((data) => (
                          <img
                            src={data}
                            alt={property.property_id}
                            className="img-fluid mb-2"
                          />
                        ))
                      ) : (
                        <p>No data found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="card service-card p-3 shadow-sm">
                  <div className="card-body">
                    <h6 className="card-title fs-5">Property Documents</h6>
                    <div className="text-center">
                      {property.property_documents_url?.length ? (
                        property.property_documents_url.map((data) => (
                          <img
                            src={data}
                            alt={property.property_id}
                            className="img-fluid mb-2"
                          />
                        ))
                      ) : (
                        <p>No data found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </>)
      }

      <ScheduleMeetBanner /><br></br><br></br> 
      <Testimonial /> 
      {/* <AppDownload /> */}
      <Newsletter /> 
      <FAQ />
      <Footer />


    </>
  );
};

export default PropertyUserViewAuctionDetail;
